import { render, staticRenderFns } from "./InternationalIntro.vue?vue&type=template&id=233835e1&"
import script from "./InternationalIntro.vue?vue&type=script&lang=js&"
export * from "./InternationalIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports